export default __webpack_public_path__ + "static/media/emptyQuiz.d02f373d.png";